<template>
    <ul class="footer__paysistems">
        <li style="width: 77px; height: 25px">
            <img src="@/assets/images/visa.svg" alt="Visa" />
        </li>
        <li style="width: 41px; height: 25px">
            <img src="@/assets/images/mastercard.svg" alt="Mastercard" />
        </li>
    </ul>
</template>

<script>
export default {};
</script>

<style
  lang="scss"
  scoped
>
.footer__paysistems {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>